import React from 'react';

const PopupClose = () => {
  return <button className="popup__close tilda__close" type="button"></button>;
};

export default PopupClose;
